import _typeof from "@babel/runtime/helpers/esm/typeof";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
var _excluded = ["disabled", "element", "placeholder", "size", "locale", "onClear", "isBorderRound", "block", "style", "className"];
import * as React from 'react';
import _omit from 'lodash/omit';
import CloseCircleFilled from '@bedrock/icons-react/CloseCircleFilled';
import InputCount, { resetValueWhenUseChinese } from './InputCount';
import { fixControlledValue } from '../utils';
import createMoveCaretManager from './utils/moveCaretManager';
export var INPUT_PREFIX_CLS = 'input';

var InputBase = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(InputBase, _React$PureComponent);

  var _super = _createSuper(InputBase);

  function InputBase(props) {
    var _this;

    _classCallCheck(this, InputBase);

    _this = _super.call(this, props);
    _this.inComposition = false;
    _this.input = void 0;

    _this.onBlur = function (e) {
      var onBlur = _this.props.onBlur;

      _this.setState({
        focused: false
      });

      _this.state.moveCaretManager.handleBlur();

      onBlur && onBlur(e);
    };

    _this.onFocus = function (e) {
      var onFocus = _this.props.onFocus;

      _this.setState({
        focused: true
      }); // 预防使用方意外手动调用onFocus的情况


      if (e.target instanceof HTMLElement) {
        _this.state.moveCaretManager.requestMoveCaret(e.target);
      }

      onFocus && onFocus(e);
    };

    _this.onChange = function (e) {
      var chineseAsTwoChars = _this.props.chineseAsTwoChars;
      var maxLength = _this.state.maxLength;

      if (chineseAsTwoChars && _this.input && !_this.inComposition) {
        e = resetValueWhenUseChinese(e, _this.input, maxLength);
      }

      _this.onChangeValue(e);
    };

    _this.onChangeValue = function (e) {
      var _this$props = _this.props,
          value = _this$props.value,
          onChange = _this$props.onChange;

      if (value === undefined) {
        _this.setState({
          value: e.target.value
        });
      }

      if (onChange) {
        onChange(e);
      }
    };

    _this.onCompositionStart = function (e) {
      // @ts-ignore
      var onCompositionStart = _this.props.onCompositionStart;
      _this.inComposition = true;
      typeof onCompositionStart === 'function' && onCompositionStart(e);
    };

    _this.onCompositionEnd = function (e) {
      var maxLength = _this.props.maxLength; // @ts-ignore

      var onCompositionEnd = _this.props.onCompositionEnd;
      _this.inComposition = false;
      typeof onCompositionEnd === 'function' && onCompositionEnd(e); // @ts-ignore

      if (maxLength !== undefined && e.target && typeof e.target.value === 'string' && !_this.inComposition) {
        // @ts-ignore
        e.target.value = e.target.value.slice(0, maxLength);
      }

      _this.onChange(e);
    };

    _this.onKeyDown = function (e) {
      var _this$props2 = _this.props,
          onKeyDown = _this$props2.onKeyDown,
          onPressEnter = _this$props2.onPressEnter;

      if (onKeyDown) {
        onKeyDown(e);
      }

      if (e.key === 'Enter' && onPressEnter) {
        onPressEnter(e);
      }
    };

    _this.onInput = function (e) {
      var _this$props3 = _this.props,
          onInput = _this$props3.onInput,
          maxLength = _this$props3.maxLength; // @ts-ignore

      if (maxLength !== undefined && e.target && typeof e.target.value === 'string' && !_this.inComposition) {
        // @ts-ignore
        e.target.value = e.target.value.slice(0, maxLength);
      }

      typeof onInput === 'function' && onInput(e);
    };

    _this.onClear = function (e) {
      var onClear = _this.props.onClear;
      typeof onClear === 'function' && onClear(e);
    };

    _this.getPrettyCls = function (modifiers) {
      var _this$props4 = _this.props,
          prefixCls = _this$props4.prefixCls,
          getPrettyCls = _this$props4.getPrettyCls;
      return getPrettyCls(INPUT_PREFIX_CLS, prefixCls)(modifiers);
    };

    _this.setInputRef = function (input) {
      _this.input = input;
    };

    var autoFocus = props.autoFocus,
        defaultValue = props.defaultValue,
        _maxLength = props.maxLength,
        _value = props.value;
    _this.state = {
      focused: !!autoFocus,
      maxLength: _maxLength,
      prevValue: _value,
      value: _value !== undefined ? _value : defaultValue,
      moveCaretManager: createMoveCaretManager(_assertThisInitialized(_this))
    };
    return _this;
  }

  _createClass(InputBase, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.state.moveCaretManager.setup();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prev) {// console.log(prev)
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.state.moveCaretManager.teardown();
    }
  }, {
    key: "renderInputCount",
    value: function renderInputCount() {
      var _this$props5 = this.props,
          chineseAsTwoChars = _this$props5.chineseAsTwoChars,
          maxLength = _this$props5.maxLength,
          prefixCls = _this$props5.prefixCls,
          showCount = _this$props5.showCount,
          showCountWhenFocused = _this$props5.showCountWhenFocused,
          countPosition = _this$props5.countPosition,
          element = _this$props5.element;
      var value = this.state.value; // Input基础组件下，contPosition = middle会出现遮挡suffix的情况，所以这时不会显示
      // 这种情况，inputCount会显示在suffix中

      var needToShowCount = (showCount || showCountWhenFocused) && (element === 'textarea' || countPosition === 'bottom');
      var countType = typeof needToShowCount !== 'string' ? 'default' : needToShowCount;
      return needToShowCount && /*#__PURE__*/React.createElement(InputCount, {
        chineseAsTwoChars: chineseAsTwoChars,
        maxLength: maxLength,
        prefixCls: prefixCls,
        value: value,
        type: countType,
        position: countPosition
      });
    }
  }, {
    key: "renderInputElement",
    value: function renderInputElement() {
      var _this$props6 = this.props,
          disabled = _this$props6.disabled,
          element = _this$props6.element,
          placeholder = _this$props6.placeholder,
          size = _this$props6.size,
          locale = _this$props6.locale,
          onClear = _this$props6.onClear,
          isBorderRound = _this$props6.isBorderRound,
          block = _this$props6.block,
          style = _this$props6.style,
          className = _this$props6.className,
          rest = _objectWithoutProperties(_this$props6, _excluded);

      var _this$state = this.state,
          focused = _this$state.focused,
          maxLength = _this$state.maxLength,
          value = _this$state.value;
      var elementType = element || 'input';
      var inputSize = !element && size;
      var inputClass = this.getPrettyCls({
        element: element,
        disabled: disabled,
        focused: focused,
        inputSize: inputSize // 'border-round': isBorderRound,

      });

      var inputProps = _omit(rest, ['chineseAsTwoChars', 'colorType', 'prefix', 'prefixCls', 'showCount', 'showCountWhenFocused', 'countPosition', 'suffix', 'getPrettyCls', 'onPressEnter', 'allowClear', 'addonBefore', 'addonAfter', 'fill', 'border', 'circle', 'allowResize', 'value', 'defaultValue', 'round', 'maxLength', 'focusCaret']);

      return /*#__PURE__*/React.createElement(elementType, _objectSpread(_objectSpread({}, inputProps), {}, {
        className: inputClass,
        disabled: disabled,
        // maxLength,
        placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : locale === null || locale === void 0 ? void 0 : locale.placeholder,
        ref: this.setInputRef,
        value: fixControlledValue(value),
        onChange: this.onChange,
        onCompositionEnd: this.onCompositionEnd,
        onCompositionStart: this.onCompositionStart,
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        onKeyDown: this.onKeyDown,
        onInput: this.onInput
      }));
    }
  }, {
    key: "renderPrefix",
    value: function renderPrefix() {
      var _this2 = this;

      var prefix = this.props.prefix;
      return !!prefix && /*#__PURE__*/React.createElement("div", {
        className: this.getPrettyCls('prefix'),
        onClick: function onClick() {
          return _this2.focus();
        }
      }, prefix);
    }
  }, {
    key: "renderSuffix",
    value: function renderSuffix() {
      var _this3 = this;

      var _this$props7 = this.props,
          suffix = _this$props7.suffix,
          allowClear = _this$props7.allowClear,
          showCount = _this$props7.showCount,
          countPosition = _this$props7.countPosition,
          showCountWhenFocused = _this$props7.showCountWhenFocused,
          element = _this$props7.element,
          prefixCls = _this$props7.prefixCls,
          chineseAsTwoChars = _this$props7.chineseAsTwoChars,
          maxLength = _this$props7.maxLength;
      var value = this.state.value;
      var clearShow = allowClear && value !== '' && value !== undefined;
      var needToShowCount = (showCount || showCountWhenFocused) && element !== 'textarea' && countPosition === 'middle';
      var suffixNode = suffix;

      if ( /*#__PURE__*/React.isValidElement(suffix) && suffix.key == null) {
        suffixNode = /*#__PURE__*/React.cloneElement(suffix, {
          key: 'input-suffix'
        });
      }

      return (!!suffix || clearShow || needToShowCount) && /*#__PURE__*/React.createElement("div", {
        className: this.getPrettyCls('suffix'),
        onClick: function onClick() {
          return _this3.focus();
        }
      }, [this.renderClearSuffix(), suffixNode, needToShowCount ? /*#__PURE__*/React.createElement(InputCount, {
        key: "count",
        chineseAsTwoChars: chineseAsTwoChars,
        maxLength: maxLength,
        prefixCls: prefixCls,
        value: value,
        position: countPosition
      }) : null]);
    }
  }, {
    key: "renderClearSuffix",
    value: function renderClearSuffix() {
      var _this4 = this;

      var _this$props8 = this.props,
          allowClear = _this$props8.allowClear,
          disabled = _this$props8.disabled,
          onChange = _this$props8.onChange;
      var value = this.state.value;
      var clearShow = allowClear && value !== '' && value !== undefined && !disabled;

      var handleClickClear = function handleClickClear(e) {
        _this4.setState({
          value: undefined
        }, function () {
          var _this4$input;

          if (_this4.input) {
            _this4.input.value = '';
          }

          var changeEvent = {
            target: _this4.input,
            currentTarget: _this4.input,
            originValue: (_this4$input = _this4.input) === null || _this4$input === void 0 ? void 0 : _this4$input.value
          };

          if (onChange) {
            onChange(changeEvent);
          }

          _this4.onClear(e);

          _this4.focus();
        });
      };

      var ClearItem = clearShow ? /*#__PURE__*/React.createElement(CloseCircleFilled, {
        key: "clear",
        className: this.getPrettyCls('suffix-clear-icon'),
        onClick: handleClickClear
      }) : null;
      return ClearItem;
    }
  }, {
    key: "renderAddonBefore",
    value: function renderAddonBefore() {
      var _this$props9 = this.props,
          addonBefore = _this$props9.addonBefore,
          prefixCls = _this$props9.prefixCls,
          size = _this$props9.size;

      if (!addonBefore) {
        return null;
      }

      var _this$props10 = this.props,
          getPrettyCls = _this$props10.getPrettyCls,
          disabled = _this$props10.disabled;
      var className = getPrettyCls("".concat(INPUT_PREFIX_CLS, "-group"), prefixCls)({
        addon: true,
        'addon-before': true
      });
      return /*#__PURE__*/React.createElement("div", {
        className: className
      }, /*#__PURE__*/React.cloneElement(addonBefore, {
        size: size,
        disabled: disabled || (_typeof(addonBefore) === 'object' && addonBefore.props ? addonBefore.props.disabled : false)
      }));
    }
  }, {
    key: "renderAddonAfter",
    value: function renderAddonAfter() {
      var _this$props11 = this.props,
          prefixCls = _this$props11.prefixCls,
          addonAfter = _this$props11.addonAfter,
          size = _this$props11.size;

      if (!addonAfter) {
        return null;
      }

      var _this$props12 = this.props,
          getPrettyCls = _this$props12.getPrettyCls,
          disabled = _this$props12.disabled;
      var className = getPrettyCls("".concat(INPUT_PREFIX_CLS, "-group"), prefixCls)({
        addon: true,
        'addon-after': true
      });
      return /*#__PURE__*/React.createElement("div", {
        className: className
      }, /*#__PURE__*/React.cloneElement(addonAfter, {
        size: size,
        disabled: disabled || (_typeof(addonAfter) === 'object' && addonAfter.props ? addonAfter.props.disabled : false)
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props13 = this.props,
          className = _this$props13.className,
          disabled = _this$props13.disabled,
          element = _this$props13.element,
          getPrettyCls = _this$props13.getPrettyCls,
          prefix = _this$props13.prefix,
          prefixCls = _this$props13.prefixCls,
          showCount = _this$props13.showCount,
          showCountWhenFocused = _this$props13.showCountWhenFocused,
          size = _this$props13.size,
          suffix = _this$props13.suffix,
          allowClear = _this$props13.allowClear,
          addonBefore = _this$props13.addonBefore,
          addonAfter = _this$props13.addonAfter,
          inputType = _this$props13.inputType,
          fill = _this$props13.fill,
          round = _this$props13.round,
          border = _this$props13.border,
          _this$props13$allowRe = _this$props13.allowResize,
          allowResize = _this$props13$allowRe === void 0 ? true : _this$props13$allowRe,
          block = _this$props13.block,
          style = _this$props13.style;
      var focused = this.state.focused;
      var hasAffix = !!(prefix || suffix || allowClear);
      var hasAddon = !!(addonBefore || addonAfter);
      var inputSize = !element && size;
      var needToShowCount = showCount || showCountWhenFocused;
      var classString = getPrettyCls("".concat(INPUT_PREFIX_CLS, "-wrapper"), prefixCls)({
        disabled: disabled,
        focused: focused,
        size: inputSize,
        'has-before': !!addonBefore,
        'has-after': !!addonAfter,
        fill: fill,
        'no-border': border === false,
        'border-bottom': border === 'bottom',
        selector: inputType === 'selector',
        round: round,
        'not-allow-resize': !allowResize,
        'has-count': needToShowCount,
        'show-count-when-focused': showCountWhenFocused,
        inline: !block
      }, '', className);

      if (hasAffix || needToShowCount || allowClear || hasAddon) {
        var affixCls = hasAffix || needToShowCount ? getPrettyCls("".concat(INPUT_PREFIX_CLS, "-affix-wrapper"), prefixCls)({}) : getPrettyCls("".concat(INPUT_PREFIX_CLS, "-affix-noop"), prefixCls)({});
        return /*#__PURE__*/React.createElement("div", {
          className: classString,
          style: style
        }, this.renderAddonBefore(), /*#__PURE__*/React.createElement("div", {
          className: affixCls
        }, this.renderPrefix(), this.renderInputElement(), this.renderSuffix()), this.renderAddonAfter(), this.renderInputCount());
      }

      return /*#__PURE__*/React.createElement("div", {
        className: classString,
        style: style
      }, this.renderInputElement());
    }
  }, {
    key: "blur",
    value: function blur() {
      var _this$input;

      (_this$input = this.input) === null || _this$input === void 0 ? void 0 : _this$input.blur();
    }
  }, {
    key: "focus",
    value: function focus() {
      var _this$input2;

      (_this$input2 = this.input) === null || _this$input2 === void 0 ? void 0 : _this$input2.focus();
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var value = nextProps.value;
      var prevValue = prevState.prevValue;

      if (value !== prevValue || value !== undefined) {
        return {
          prevValue: value,
          value: value
        };
      }

      return null;
    }
  }]);

  return InputBase;
}(React.PureComponent);

InputBase.defaultProps = {
  block: false,
  chineseAsTwoChars: false,
  countPosition: 'middle'
};
export default InputBase;